'use es6';

import { PREVIEW_OPTIONS_FETCH, PREVIEW_OPTIONS_SAVE, PREVIEW_OPTIONS_DELETE, PREVIEW_OPTIONS_UPDATE_PREVIEW_CONFIGURATION, PREVIEW_OPTIONS_TOGGLE_PREVIEW, PREVIEW_OPTIONS_FETCH_BUILDS, PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD } from 'DesignData/actions/ActionTypes';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
import { getIsDFSProjectsUngated } from 'DesignData/selectors/gates';
import * as client from 'DesignData/api/PreviewOptions';
import * as projectsClient from 'DesignData/api/Projects';
import * as templatesClient from 'DesignData/api/Templates';
import { createAsyncActions } from 'DesignData/lib/actions';
const getAsyncActions = createAsyncActions.bind(null, 'previewOptions');
/**
 * Fetch persisted preview options - for application startup.
 */

export function fetch() {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = fetch;
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.fetch(userId, portalId).then(previewOptions => dispatch(receive(previewOptions))).catch(err => dispatch(error(err)));
  };
}
Object.assign(fetch, getAsyncActions(PREVIEW_OPTIONS_FETCH));
/**
 * Save preview options.
 */

export function save() {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = save;
    const state = getState();
    const {
      previewOptions
    } = state;
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.save(userId, portalId, previewOptions).then(__previewOptions => dispatch(receive(__previewOptions))).catch(err => dispatch(error(err)));
  };
}
Object.assign(save, getAsyncActions(PREVIEW_OPTIONS_SAVE));
/**
 * Remove preview options for asset. Do this when the asset is deleted.
 *
 * @param {(Number|String)} assetId
 */

export function del(assetId) {
  return {
    type: PREVIEW_OPTIONS_DELETE,
    assetId
  };
}
/**
 * Update preview configuration.
 *
 * @param {(Number|String)} assetId
 * @param {Object}          previewConfiguration
 */

export function updatePreviewConfiguration(assetId, previewConfiguration) {
  return {
    type: PREVIEW_OPTIONS_UPDATE_PREVIEW_CONFIGURATION,
    assetId,
    previewConfiguration
  };
}
/**
 * Open/close preview.
 *
 * @param {(Number|String)} assetId
 */

export function togglePreview(assetId) {
  return {
    type: PREVIEW_OPTIONS_TOGGLE_PREVIEW,
    assetId
  };
}
export function fetchBuilds(projectName) {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = fetchBuilds;
    const isProjectsUngated = getIsDFSProjectsUngated(getState());

    if (!isProjectsUngated) {
      return Promise.resolve(null);
    }

    if (!projectName) {
      dispatch(receive());
    }

    dispatch(request());
    return projectsClient.fetchProjects().then(response => {
      const project = response.results.find(proj => proj.name === projectName);

      if (project) {
        return projectsClient.fetchBuilds(project.name).then(resp => {
          return dispatch(receive(resp.results));
        });
      }

      return dispatch(receive());
    }).catch(err => {
      dispatch(error(err));
    });
  };
}

fetchBuilds.request = () => {
  return {
    type: PREVIEW_OPTIONS_FETCH_BUILDS
  };
};

fetchBuilds.receive = buildList => {
  return {
    type: PREVIEW_OPTIONS_FETCH_BUILDS,
    buildList
  };
};

fetchBuilds.error = error => {
  return {
    type: PREVIEW_OPTIONS_FETCH_BUILDS,
    error
  };
};

export function checkIfTemplateBelongsToBuild(deployId, path) {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = checkIfTemplateBelongsToBuild;
    const isProjectsUngated = getIsDFSProjectsUngated(getState());

    if (!isProjectsUngated) {
      return Promise.resolve(null);
    }

    dispatch(request(false));
    return templatesClient.fetchTemplateByBuild(deployId, path).then(response => {
      if (response.objects.length) {
        return dispatch(receive(true, deployId));
      }

      return dispatch(receive(false, deployId));
    }).catch(err => dispatch(error(err)));
  };
}

checkIfTemplateBelongsToBuild.request = isTemplateInBuild => {
  return {
    type: PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD,
    isTemplateInBuild
  };
};

checkIfTemplateBelongsToBuild.receive = (isTemplateInBuild, deployId) => {
  return {
    type: PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD,
    isTemplateInBuild,
    deployId
  };
};

checkIfTemplateBelongsToBuild.error = error => {
  return {
    type: PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD,
    error
  };
};